// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = (): void => {}
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noopAsync = async (): Promise<void> => {}
